<template>
  <div id="app" style="max-width: 600px;margin: 0 auto;border: 1px solid #ccc;">
    <router-view/>
  </div>
</template>

<script>
import { getMemberToken } from '@/utils/auth'
export default {
  name: 'App',
  data() {
    return {
    }
  },
  beforeCreate() {
  },
  created() {
    this.checkLogin()
  },
  mounted() {
  },
  methods: {
    checkLogin() {
      const token = getMemberToken()
      if (!token) {
        this.$router.replace('/login')
      }
    },
  }
}
</script>

<style>
#app {
  /*font-family: "宋体","仿体",'STFANGSO';*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #f0f5fd;
  height: 100vh;
}
.familyinfo .van-field__control.van-field__control--custom{
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/App.vue